"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentClient = void 0;
const axios_1 = __importDefault(require("axios"));
const PaymentClient_types_1 = require("./PaymentClient.types");
const config_1 = require("./config");
const axios_retry_1 = __importStar(require("axios-retry"));
class PaymentClient {
  constructor(config) {
    this.client = axios_1.default.create(config_1.defaultConfig);
    this.deviceSerialNumber = null;
    this.disablePrinting = undefined;
    this.dnaRetries = 0;
    this.retryLogs = [];
    this.delay = async function () {
      let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      return new Promise(resolve => {
        setTimeout(resolve, timeout);
      });
    };
    this.deviceSerialNumber = config.serialNumber || null;
    this.disablePrinting = config.disablePrinting || undefined;
    this.clientName = config.clientName;
    this.client.interceptors.request.use(request => {
      if (config.debug) {
        console.log("Request:", request.url, request.method, request.params, request.data);
      }
      return request;
    });
    this.client.interceptors.response.use(response => {
      if (config.debug) {
        console.log("Response:", response.request.responseURL, response.status, response.statusText);
      }
      return response;
    }, error => {
      if (config.debug) {
        console.error("Error:", error.config.url, error.code, error.message, error.name, error.stack);
      }
      return Promise.reject(error);
    });
  }
  get reference() {
    return new Date().getTime().toString();
  }
  async getInfo() {
    const config = Object.assign(Object.assign({}, config_1.defaultConfig), {
      timeout: 2000
    });
    try {
      const response = await this.client.get("/info", config);
      return response.data.DeviceInfo;
    } catch (err) {
      throw new Error("Failed to get device info", {
        cause: err
      });
    }
  }
  async setDeviceSerialNumber() {
    if (!this.deviceSerialNumber) {
      const {
        serialNumber
      } = await this.getInfo();
      this.deviceSerialNumber = serialNumber;
    }
  }
  async validateSerialNumber(serialNumber) {
    const config = {
      params: {
        tid: serialNumber
      }
    };
    const payload = {
      transType: "SALE",
      amountGratuity: 0,
      amountTrans: 1,
      reference: "VALIDATE_SERIAL_NUMBER"
    };
    const {
      data
    } = await this.client.post("/transaction", payload, config);
    await this.delay();
    await this.client.delete("/transaction", config);
    return data;
  }
  async initTransaction(_ref) {
    let {
      amount,
      restaurantId,
      checkNumber,
      waiterId,
      donationAmount = 0,
      tipAmount = 0,
      sendAmountToPennies = false
    } = _ref;
    await this.setDeviceSerialNumber();
    const reference = this.createPaymentReference({
      restaurantId,
      checkNumber,
      waiterId
    });
    const config = {
      params: {
        tid: this.deviceSerialNumber,
        disablePrinting: this.disablePrinting
      }
    };
    const payload = Object.assign(Object.assign({
      transType: "SALE",
      amountGratuity: tipAmount,
      amountTrans: amount
    }, sendAmountToPennies && {
      amountPennies: donationAmount
    }), {
      reference
    });
    const response = await this.client.post("/transaction", payload, config);
    const {
      data
    } = response;
    return data;
  }
  createPaymentReference(_ref2) {
    let {
      restaurantId,
      checkNumber,
      waiterId
    } = _ref2;
    const paymentReference = `${this.clientName}_${this.reference}_${waiterId}T_${restaurantId}S_${checkNumber}C`;
    return paymentReference.substring(0, config_1.MAX_REFERENCE_LENGTH);
  }
  async getTransaction(transactionId) {
    (0, axios_retry_1.default)(this.client);
    const config = {
      params: {
        tid: this.deviceSerialNumber,
        uti: transactionId
      },
      timeout: 1000,
      "axios-retry": {
        retries: 3,
        onRetry: (_, error) => {
          this.dnaRetries = this.dnaRetries += 1;
          this.retryLogs.push(error);
          return;
        },
        retryDelay: count => count * 300,
        retryCondition: error => (0, axios_retry_1.isNetworkOrIdempotentRequestError)(error) || error.code === "ECONNABORTED"
      }
    };
    const response = await this.client.get("/transaction", config);
    return response;
  }
  async deleteTransaction() {
    const config = {
      params: {
        tid: this.deviceSerialNumber
      }
    };
    const response = await this.client.delete("/transaction", config);
    return response;
  }
  async pollTransaction(transactionId) {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          if (this.dnaRetries > 3) {
            reject({
              data: {
                retries: this.dnaRetries,
                retryLogs: this.retryLogs
              },
              msg: "Transaction exceeds retry limit"
            });
            return;
          }
          const transaction = await this.getTransaction(transactionId);
          if ((transaction === null || transaction === void 0 ? void 0 : transaction.status) === PaymentClient_types_1.TransactionStatus.TRANSACTION_IN_PROGRESS) {
            return;
          }
          const returnData = Object.assign(Object.assign({}, transaction.data), {
            retries: this.dnaRetries,
            retryLogs: this.retryLogs
          });
          if ((transaction === null || transaction === void 0 ? void 0 : transaction.status) === PaymentClient_types_1.TransactionStatus.TRANSACTION_COMPLETE) {
            if (transaction.data.transApproved) {
              resolve(Object.assign(Object.assign({}, transaction), {
                data: returnData
              }));
              clearInterval(interval);
              return;
            }
            if (transaction.data.transCancelled) {
              reject({
                data: returnData,
                msg: "Transaction cancelled"
              });
              clearInterval(interval);
              return;
            }
            if (!transaction.data.transCancelled && !transaction.data.transApproved) {
              reject({
                data: returnData,
                msg: "Transaction declined"
              });
              clearInterval(interval);
              return;
            }
          }
          clearInterval(interval);
          reject({
            data: returnData,
            msg: "Transaction failed"
          });
        } catch (err) {
          reject(err);
          clearInterval(interval);
        }
      }, 300);
    });
  }
  async pollTransactionV2(transactionId) {
    return new Promise((resolve, reject) => {
      const polling = async () => {
        try {
          if (this.dnaRetries > 3) {
            reject({
              data: {
                retries: this.dnaRetries,
                retryLogs: this.retryLogs
              },
              msg: "Transaction exceeds retry limit"
            });
            return;
          }
          const transaction = await this.getTransaction(transactionId);
          if ((transaction === null || transaction === void 0 ? void 0 : transaction.status) === PaymentClient_types_1.TransactionStatus.TRANSACTION_IN_PROGRESS) {
            setTimeout(polling, 300);
            return;
          }
          const returnData = Object.assign(Object.assign({}, transaction.data), {
            retries: this.dnaRetries,
            retryLogs: this.retryLogs
          });
          if ((transaction === null || transaction === void 0 ? void 0 : transaction.status) === PaymentClient_types_1.TransactionStatus.TRANSACTION_COMPLETE) {
            if (transaction.data.transApproved) {
              resolve(Object.assign(Object.assign({}, transaction), {
                data: returnData
              }));
              return;
            }
            if (transaction.data.transCancelled) {
              reject({
                data: returnData,
                msg: "Transaction cancelled"
              });
              return;
            }
            if (!transaction.data.transCancelled && !transaction.data.transApproved) {
              reject({
                data: returnData,
                msg: "Transaction declined"
              });
              return;
            }
          }
          reject({
            data: returnData,
            msg: "Transaction failed"
          });
        } catch (err) {
          reject(err);
        }
      };
      polling();
    });
  }
}
exports.PaymentClient = PaymentClient;